<template>
  <div class="ls-nowrap">
    <slot name="button"></slot>
    <slot name="dropdown"></slot>
  </div>
</template>
<script type="text/javascript">
  export default {
    props: ['width'],
    mounted () {
      window.addEventListener('resize', this.checkResolution)
      this.checkResolution()
    },
    methods: {
      toggleButtons (interactor) {
        var buttons = this.$slots.button
        if (buttons === undefined) return
        buttons.forEach(interactor)
      },
      hideButton (button) {
        this.hideElement(button.elm)
      },
      showButton (button) {
        this.showElement(button.elm)
      },
      hideElement (element) {
        if (element.className.indexOf('ls-display-none') >= 0) return
        element.className += ' ls-display-none'
      },
      showElement (element) {
        element.className = element.className.replace(/ls-display-none/g, '')
      },
      cloneButtons () {
        var buttons = this.$slots.button
        if (buttons === undefined) return
        buttons.reverse().forEach(this.cloneButton)
      },
      cloneButton (button) {
        var element = this.transformButton(button)
        var list = this.getListElement()
        if (list) {
          list.insertBefore(element, list.children[0])
        }
      },
      transformButton (button) {
        var btn = button.elm.cloneNode(true)
        btn.className = btn.className.replace(/btn/g, 'color')
        btn.href = btn.pathname
        btn.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          button.elm.click()
        })

        var element = document.createElement('li')
        element.className = 'custom-regroup'
        element.appendChild(btn)

        return element
      },
      findListElements () {
        var list = this.getListElement()
        if (list !== null) {
          return document.getElementsByClassName('custom-regroup', list)
        }
      },
      getListElement () {
        var dropdown = this.$slots.dropdown
        if (dropdown !== undefined) {
          var list = dropdown[0].child.$slots.list
          if (list !== undefined) {
            return list[0].elm
          }
        }
        return null
      },
      removeButtons () {
        var buttons = this.findListElements()
        if (!buttons) return
        for (var button of buttons) {
          button.remove()
        }
      },
      checkResolution () {
        if (window.innerWidth <= this.width) {
          this.cloneButtons()
          this.toggleButtons(this.hideButton)
        } else {
          this.removeButtons()
          this.toggleButtons(this.showButton)
        }
      }
    }
  }
</script>
<style lang="scss">
  .inside {
    min-height: 100px;
    min-width: 100px;
    background-color: blue;
  }
</style>



// WEBPACK FOOTER //
// Regroup.vue?f288af46